import { useMediaQuery } from '@mantine/hooks'
import type { Breakpoint } from '../tailwind'
import { breakpoints } from '../tailwind'

export const useIsMobile = () => {
  return useBreakpoint('mmd', 'down')
}

const getMediaQueryForBreakpoint = (
  key: Breakpoint,
  dir: 'down' | 'up' = 'down',
) => {
  const value = breakpoints[key]
  if (dir === 'down') {
    return `(width < ${value})`
  } else {
    return `(width >= ${value})`
  }
}

export const useBreakpoint = (key: Breakpoint, dir: 'down' | 'up' = 'down') => {
  return useMediaQuery(getMediaQueryForBreakpoint(key, dir), undefined, {
    // This is to make sure it will return the correct value at first render
    // (instead of return undefined and update it in effect)
    getInitialValueInEffect: false,
  })
}

export function getIsMobile() {
  return testMediaQuery(getMediaQueryForBreakpoint('mmd', 'down'))
}

export function testMediaQuery(mediaQuery: string) {
  return window.matchMedia(mediaQuery).matches
}

export const useIsLg = () => {
  // matches tailwind lg
  return useBreakpoint('lg', 'up')
}

export const useIsXsMobile = () => {
  return useMediaQuery('(max-width:400px)')
}
